module.exports = __webpack_public_path__ + "static/media/abbiamo13.3550be8a.png";